/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AddressType {
  Billing = "Billing",
  Delivery = "Delivery",
  Head = "Head",
}

export enum DeliveryFeeOrigin {
  Auto = "Auto",
  Franco = "Franco",
  FreeManual = "FreeManual",
}

export enum DeliveryStatus {
  Delivered = "Delivered",
  Failed = "Failed",
  InProgress = "InProgress",
  Planned = "Planned",
  ToPlan = "ToPlan",
}

export enum MailDirection {
  Incoming = "Incoming",
  Outgoing = "Outgoing",
}

export enum OrderStatus {
  Cancelled = "Cancelled",
  Draft = "Draft",
  InSignature = "InSignature",
  Signed = "Signed",
}

export enum PaymentStatus {
  Paid = "Paid",
  Partial = "Partial",
  Unpaid = "Unpaid",
}

export enum PriceOrigin {
  Manual = "Manual",
  PriceRule = "PriceRule",
}

export enum ProspectionType {
  Email = "Email",
  Phone = "Phone",
}

export enum QrCodeStatus {
  Assigned = "Assigned",
  Available = "Available",
}

export enum ScanAction {
  Delivery = "Delivery",
  InventoryCheck = "InventoryCheck",
  PickUp = "PickUp",
  Return = "Return",
}

export enum SignatureMode {
  InPerson = "InPerson",
  Remote = "Remote",
}

export enum StockExitReason {
  Issue = "Issue",
  Promotion = "Promotion",
  Sold = "Sold",
}

export enum Table {
  Contact = "Contact",
  Customer = "Customer",
  CustomerAddress = "CustomerAddress",
  GivenCans = "GivenCans",
  MailMessage = "MailMessage",
  Order = "Order",
  OrderLine = "OrderLine",
  PriceRule = "PriceRule",
  Product = "Product",
  Prospection = "Prospection",
  StockUnit = "StockUnit",
  Task = "Task",
  Visit = "Visit",
}

export enum TaskPriority {
  High = "High",
  Low = "Low",
  Medium = "Medium",
}

export enum TaskStatus {
  Cancelled = "Cancelled",
  Done = "Done",
  InProgress = "InProgress",
  Todo = "Todo",
}

export enum UserRole {
  Admin = "Admin",
  Client = "Client",
  Employee = "Employee",
}

export enum VisitOutcome {
  NoAction = "NoAction",
  Order = "Order",
  Quote = "Quote",
  ToFollowUp = "ToFollowUp",
}

export interface ContactsFiltersInput {
  search?: string | null;
  customerId?: number | null;
  addressId?: number | null;
  jobTitleId?: number | null;
  active?: boolean | null;
}

export interface CreateCategoryInput {
  name: string;
}

export interface CreateContactInput {
  civility: string;
  lastname?: string | null;
  firstname: string;
  email?: string | null;
  phone: string;
  isPrimary: boolean;
  active: boolean;
  notes: string;
  customerId: number;
  addressId?: number | null;
  jobTitleId?: number | null;
}

export interface CreateCustomerAddressInput {
  streetNumber: string;
  street: string;
  postal: string;
  city: string;
  type: AddressType;
  label: string;
  siret?: string | null;
  isMain: boolean;
  deliveryNotes: string;
  active: boolean;
  customerId: number;
}

export interface CreateCustomerInput {
  name: string;
  email?: string | null;
  siren?: string | null;
  phone: string;
  categoryId?: number | null;
}

export interface CreateEmailLogInput {
  recipient: string;
  sentAt: any;
  status: string;
  messageId?: string | null;
  orderId: number;
}

export interface CreateGivenCansInput {
  quantity: number;
  comment: string;
  productId: number;
  customerId?: number | null;
}

export interface CreateJobTitleInput {
  name: string;
}

export interface CreateMailboxInput {
  email: string;
  imapHost: string;
  imapPort: number;
  smtpHost: string;
  smtpPort: number;
  password: string;
}

export interface CreateOrderInput {
  number?: string | null;
  status: OrderStatus;
  paymentStatus: PaymentStatus;
  deliveryStatus: DeliveryStatus;
  deliveryFeeOrigin: DeliveryFeeOrigin;
  plannedDeliveryAt?: any | null;
  cancelReason?: string | null;
  externalInvoiceRef?: string | null;
  customerId: number;
  deliveryAddressId?: number | null;
  contactId?: number | null;
  salesRepId: number;
  deliveryUserId?: number | null;
  visitId?: number | null;
}

export interface CreateOrderLineInput {
  frozenLabel: string;
  unitPriceCents: number;
  quantity: number;
  vatRate: number;
  priceOrigin: PriceOrigin;
  overrideReason?: string | null;
  orderId: number;
  productId: number;
  appliedPriceRuleId?: number | null;
}

export interface CreatePriceRuleInput {
  quantity: number;
  priceCents: number;
  productId: number;
  customerId?: number | null;
}

export interface CreateProductInput {
  name: string;
  url: string;
  imgUrl: string;
  reference: string;
  lastPrice: number;
}

export interface CreateProspectionInput {
  type: ProspectionType;
  phone?: string | null;
  email?: string | null;
  message: string;
  customerId?: number | null;
}

export interface CreateSessionInput {
  jetonHash: string;
  expiresAt: any;
  userId: number;
}

export interface CreateSignatureInput {
  imagePng: string;
  signerName: string;
  signerRole: string;
  signerEmail?: string | null;
  signedAt: any;
  ip?: string | null;
  userAgent?: string | null;
  documentHashSha256: string;
  mode: SignatureMode;
  lat?: number | null;
  lng?: number | null;
  accuracyM?: number | null;
  orderId: number;
}

export interface CreateSignatureLinkInput {
  token: string;
  expiresAt: any;
  recipientEmail: string;
  orderId: number;
}

export interface CreateStockUnitInput {
  batchNumber: string;
  quantity: number;
  enteredAt: any;
  productId: number;
  warehouseId: number;
  qrCode: string;
}

export interface CreateTaskInput {
  title: string;
  description: string;
  status: TaskStatus;
  priority: TaskPriority;
  dueDate?: any | null;
  userId?: number | null;
  customerId?: number | null;
}

export interface CreateUserCustomerInput {
  userId: number;
  customerId: number;
}

export interface CreateUserInput {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  role: UserRole;
}

export interface CreateVisitInput {
  visitDate: any;
  report: string;
  outcome: VisitOutcome;
  followUpDate?: any | null;
  lat?: number | null;
  lng?: number | null;
  accuracyM?: number | null;
  customerId: number;
  addressId?: number | null;
  salesRepId: number;
}

export interface CreateWarehouseInput {
  name: string;
  address: string;
  active: boolean;
}

export interface CustomerAddressesFiltersInput {
  search?: string | null;
  customerId?: number | null;
  type?: AddressType | null;
  active?: boolean | null;
}

export interface CustomersFiltersInput {
  search?: string | null;
  categoryId?: number | null;
  email?: string | null;
  siren?: string | null;
  isComplete?: boolean | null;
}

export interface EmailLogsFiltersInput {
  orderId?: number | null;
  status?: string | null;
}

export interface GivenCansFiltersInput {
  productId?: number | null;
  customerId?: number | null;
  givenById?: number | null;
}

export interface JobTitlesFiltersInput {
  search?: string | null;
}

export interface LoginAsInput {
  email: string;
}

export interface LoginInput {
  email: string;
  password: string;
}

export interface MailMessagesFiltersInput {
  customerId?: number | null;
  mailboxId?: number | null;
  direction?: MailDirection | null;
}

export interface NotificationsFiltersInput {
  userId?: number | null;
  isRead?: boolean | null;
  table?: Table | null;
  objectId?: number | null;
}

export interface OrderLinesFiltersInput {
  orderId?: number | null;
  productId?: number | null;
  priceOrigin?: PriceOrigin | null;
}

export interface OrdersFiltersInput {
  search?: string | null;
  customerId?: number | null;
  salesRepId?: number | null;
  status?: OrderStatus | null;
  paymentStatus?: PaymentStatus | null;
  deliveryStatus?: DeliveryStatus | null;
}

export interface PriceRulesFiltersInput {
  productId?: number | null;
  customerId?: number | null;
  createdById?: number | null;
}

export interface ProductsFiltersInput {
  search?: string | null;
  priceOnly?: boolean | null;
  ids?: number[] | null;
  start?: string | null;
  end?: string | null;
  orderByPrice?: string | null;
  orderByCreatedAt?: string | null;
}

export interface ProspectionsFiltersInput {
  customerId?: number | null;
  sentById?: number | null;
  type?: ProspectionType | null;
}

export interface QrCodesFiltersInput {
  status?: QrCodeStatus | null;
}

export interface ScanStockUnitInput {
  qrCode: string;
  action: ScanAction;
  lat?: number | null;
  lng?: number | null;
}

export interface SendMailMessageInput {
  to: string;
  subject: string;
  body: string;
  customerId?: number | null;
}

export interface SessionsFiltersInput {
  search?: string | null;
  userId?: number | null;
}

export interface SignatureLinksFiltersInput {
  orderId?: number | null;
}

export interface SignaturesFiltersInput {
  orderId?: number | null;
  mode?: SignatureMode | null;
}

export interface StockScansFiltersInput {
  stockUnitId?: number | null;
  scannedById?: number | null;
  action?: ScanAction | null;
}

export interface StockUnitsFiltersInput {
  search?: string | null;
  productId?: number | null;
  warehouseId?: number | null;
  orderId?: number | null;
  exitReason?: StockExitReason | null;
  inStock?: boolean | null;
}

export interface TasksFiltersInput {
  search?: string | null;
  userId?: number | null;
  customerId?: number | null;
  status?: TaskStatus | null;
  priority?: TaskPriority | null;
}

export interface UpdateCategoryInput {
  name?: string | null;
}

export interface UpdateContactInput {
  civility?: string | null;
  lastname?: string | null;
  firstname?: string | null;
  email?: string | null;
  phone?: string | null;
  isPrimary?: boolean | null;
  active?: boolean | null;
  notes?: string | null;
  customerId?: number | null;
  addressId?: number | null;
  jobTitleId?: number | null;
}

export interface UpdateCustomerAddressInput {
  streetNumber?: string | null;
  street?: string | null;
  postal?: string | null;
  city?: string | null;
  type?: AddressType | null;
  label?: string | null;
  siret?: string | null;
  isMain?: boolean | null;
  deliveryNotes?: string | null;
  active?: boolean | null;
  customerId?: number | null;
}

export interface UpdateCustomerAddressLocationInput {
  lat: number;
  lng: number;
}

export interface UpdateCustomerInput {
  name?: string | null;
  email?: string | null;
  siren?: string | null;
  phone?: string | null;
  categoryId?: number | null;
}

export interface UpdateEmailLogInput {
  recipient?: string | null;
  sentAt?: any | null;
  status?: string | null;
  messageId?: string | null;
  orderId?: number | null;
}

export interface UpdateGivenCansInput {
  quantity?: number | null;
  comment?: string | null;
  customerId?: number | null;
}

export interface UpdateJobTitleInput {
  name?: string | null;
}

export interface UpdateMailboxInput {
  email?: string | null;
  imapHost?: string | null;
  imapPort?: number | null;
  smtpHost?: string | null;
  smtpPort?: number | null;
  password?: string | null;
  active?: boolean | null;
}

export interface UpdateOrderInput {
  number?: string | null;
  status?: OrderStatus | null;
  paymentStatus?: PaymentStatus | null;
  deliveryStatus?: DeliveryStatus | null;
  deliveryFeeOrigin?: DeliveryFeeOrigin | null;
  plannedDeliveryAt?: any | null;
  cancelReason?: string | null;
  externalInvoiceRef?: string | null;
  customerId?: number | null;
  deliveryAddressId?: number | null;
  contactId?: number | null;
  salesRepId?: number | null;
  deliveryUserId?: number | null;
  visitId?: number | null;
}

export interface UpdateOrderLineInput {
  frozenLabel?: string | null;
  unitPriceCents?: number | null;
  quantity?: number | null;
  vatRate?: number | null;
  priceOrigin?: PriceOrigin | null;
  overrideReason?: string | null;
  orderId?: number | null;
  productId?: number | null;
  appliedPriceRuleId?: number | null;
}

export interface UpdatePriceRuleInput {
  quantity?: number | null;
  priceCents?: number | null;
  customerId?: number | null;
}

export interface UpdateProductInput {
  name?: string | null;
  url?: string | null;
  imgUrl?: string | null;
  reference?: string | null;
  lastPrice?: number | null;
}

export interface UpdateProspectionInput {
  type?: ProspectionType | null;
  phone?: string | null;
  email?: string | null;
  message?: string | null;
  customerId?: number | null;
}

export interface UpdateSessionInput {
  jetonHash?: string | null;
  expiresAt?: any | null;
  userId?: number | null;
}

export interface UpdateSignatureInput {
  imagePng?: string | null;
  signerName?: string | null;
  signerRole?: string | null;
  signerEmail?: string | null;
  signedAt?: any | null;
  ip?: string | null;
  userAgent?: string | null;
  documentHashSha256?: string | null;
  mode?: SignatureMode | null;
  lat?: number | null;
  lng?: number | null;
  accuracyM?: number | null;
  orderId?: number | null;
}

export interface UpdateSignatureLinkInput {
  token?: string | null;
  expiresAt?: any | null;
  recipientEmail?: string | null;
  orderId?: number | null;
}

export interface UpdateStockUnitInput {
  batchNumber?: string | null;
  quantity?: number | null;
  warehouseId?: number | null;
}

export interface UpdateTaskInput {
  title?: string | null;
  description?: string | null;
  status?: TaskStatus | null;
  priority?: TaskPriority | null;
  dueDate?: any | null;
  userId?: number | null;
  customerId?: number | null;
}

export interface UpdateUserInput {
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  password?: string | null;
  role?: UserRole | null;
}

export interface UpdateVisitInput {
  visitDate?: any | null;
  report?: string | null;
  outcome?: VisitOutcome | null;
  followUpDate?: any | null;
  lat?: number | null;
  lng?: number | null;
  accuracyM?: number | null;
  customerId?: number | null;
  addressId?: number | null;
  salesRepId?: number | null;
}

export interface UpdateWarehouseInput {
  name?: string | null;
  address?: string | null;
  active?: boolean | null;
}

export interface UserCustomersFiltersInput {
  userId?: number | null;
  customerId?: number | null;
}

export interface UsersFiltersInput {
  search?: string | null;
  role?: UserRole | null;
  roles?: UserRole[] | null;
}

export interface VisitsFiltersInput {
  search?: string | null;
  customerId?: number | null;
  addressId?: number | null;
  salesRepId?: number | null;
  outcome?: VisitOutcome | null;
}

export interface WarehousesFiltersInput {
  search?: string | null;
  active?: boolean | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
